import { render, staticRenderFns } from "./DashboardImportant.vue?vue&type=template&id=6b12e447&"
import script from "./DashboardImportant.vue?vue&type=script&lang=js&"
export * from "./DashboardImportant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports